/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaStudenteListFilter { 
    nominativo?: string;
    codice_pratica?: string;
    nome_scuola?: string;
    plesso_scuola?: string;
    sezione?: string;
    classe?: string;
    pasti_residui_minori_di?: number;
    pasti_residui_maggiori_di?: number;
    is_esente?: boolean;
    is_sospeso?: boolean;
}

